import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Logo from '../assets/logo.jpeg';

const Header = () => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    // Function to handle navbar collapse on link click
    const handleLinkClick = () => {
      setIsCollapsed(true); // Collapse the navbar after link click
    };
  
    return (
        <>
            <header className='py-2'>
                <div className='container'>

                    <div className='d-flex justify-content-between'>
                        <div className='my-lg-3 my-2 d-lg-flex d-md-flex d-sm-flex d-block'>
                            <p className='my-0'><Link className='header-link my-2'><i className="fa fa-phone"></i> &nbsp;+959 933 2740</Link></p>
                            <p className='my-0'><Link className='header-link my-2'><i className="fa fa-envelope"></i> &nbsp;info@anvifoundation.com</Link></p>
                        </div>

                        <div className='my-lg-3 my-2 d-lg-block d-md-block d-none'>
                            <Link className='header-link my-2'><i className="fa-brands fa-facebook-f"></i></Link>
                            <Link className='header-link my-2'><i className="fa-brands fa-linkedin-in"></i></Link>
                            <Link className='header-link my-2'><i className="fa-brands fa-instagram"></i></Link>
                        </div>

                    </div>
                    {/* top header ends */}


                    {/* navbar section */}
                    <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
                        <div className="container-fluid">
                            <Link className="navbar-brand" to="/">
                            <img src={Logo} className='rounded' style={{height: '3.5em'}} alt='Header Logo' /></Link>
                            <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                                <ul className="navbar-nav ms-auto mb-lg-0">
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/">Home</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/about">About</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/donation">Donation</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/gallery">Gallery</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/skill-development">Skill Development</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/careers">Careers</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/privacy-policy">Privacy Policy</NavLink>
                                    </li>
                                    <li className="nav-item my-3">
                                        <NavLink className="nav-text" onClick={handleLinkClick} activeClassName='active' to="/contact">Contact</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                    {/* navbar section ends */}


                </div>
            </header>
        </>
    )
}

export default Header
